export const PLACE_HIGHER_LABEL = 'Placer plus haut';
export const PLACE_LOWER_LABEL = 'Placer plus bas';
export const MORE_ACTIONS_LABEL = "Plus d'actions";
export const ORDER_UPDATE_ERROR_MESSAGE =
  "Impossible de modifier l'ordre de la page";
